import { useSelector } from "react-redux";
import { Row, Col, Card } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import "./styles.css";
import { heartBeatFactors } from "./heartBeatFactors";
import NoData from "components/Common/NoData";

const HBTestSummary = () => {
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const test_duration =
    vehicleSlice?.vehicleDetails?.connectivityTestDuration || "";
  const HBTestRunningStatus = eol?.HBTestRunningStatus;
  const HBResultDetails = eol?.HBResultDetails;
  const connectivityResults = HBResultDetails?.data?.connectivity;
  const testSummaryList = heartBeatFactors.other.map((otherTest) => {
    const testResult = connectivityResults?.filter(
      (test) => test.name === otherTest.index
    );
    return {
      text: otherTest.text,
      value: testResult?.[0].value !== null ? testResult?.[0].value : "N/A",
      unit: testResult?.[0].value !== null ? testResult?.[0].unit : "",
    };
  });
  testSummaryList.push({
    text: "Test Duration",
    value: test_duration ? test_duration : "N/A",
    unit: test_duration ? "s" : "",
  });

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card
            className="h100"
            title="Test Summary"
            styles={{
              body: { width: "100%", padding: "4px", minHeight: "270px" },
            }}
          >
            <>
              {!HBResultDetails?.data ? (
                <NoData />
              ) : (
                testSummaryList?.map((testItem, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "15px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          flexDirection: "row",
                        }}
                      >
                        <div className="grid-result-text">{testItem.text}</div>
                        {HBTestRunningStatus ? (
                          <>
                            <div className="grid-result-text">
                              <Loading3QuartersOutlined
                                style={{
                                  fontSize: 30,
                                  animationDuration: "5s",
                                  color: "#F4F4F4",
                                }}
                                spin
                              />
                              {testItem.value + testItem.unit}
                            </div>
                          </>
                        ) : (
                          <div className="grid-result-text">
                            {testItem.value + testItem.unit}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default HBTestSummary;
